/* ═══════════════════════════════════════════════════
   NEWJAISA — BPO INDUSTRY PAGE
   File: assets/component-bpo.js
   Namespace: BpoPage · No global leaks · No jQuery
═══════════════════════════════════════════════════ */

'use strict';

var BpoPage = (function () {

  function $(id)   { return document.getElementById(id); }
  function $$(sel) { return Array.from(document.querySelectorAll(sel)); }

  /* ── FORMAT INR ─────────────────────────────── */
  function fmtINR(n) {
    if (n >= 10000000) return '₹' + (n / 10000000).toFixed(1) + ' Cr';
    if (n >= 100000)   return '₹' + (n / 100000).toFixed(1) + ' L';
    return '₹' + n.toLocaleString('en-IN');
  }

  /* ── ESTIMATOR ──────────────────────────────── */
  function calcBPO() {
    var qtyEl  = $('bpo-qty');
    var typeEl = $('bpo-type');
    if (!qtyEl || !typeEl) return;

    var qty  = parseInt(qtyEl.value) || 1;
    var vals = (typeEl.value || '18500,50000').split(',');
    var nj   = parseInt(vals[0]);
    var newP = parseInt(vals[1]);

    var disc = qty >= 500 ? 0.15
             : qty >= 100 ? 0.12
             : qty >= 50  ? 0.08
             : qty >= 10  ? 0.05 : 0;

    var njUnit   = Math.round(nj * (1 - disc));
    var njTotal  = njUnit * qty;
    var newTotal = newP   * qty;
    var saving   = newTotal - njTotal;
    var pct      = Math.round((saving / newTotal) * 100);

    var njEl   = $('bpo-nj');
    var newEl  = $('bpo-new');
    var saveEl = $('bpo-save');
    if (njEl)   njEl.textContent   = fmtINR(njTotal);
    if (newEl)  newEl.textContent  = fmtINR(newTotal);
    if (saveEl) saveEl.textContent = fmtINR(saving) + ' · ' + pct + '%';
  }

  /* ── FAQ ACCORDION ──────────────────────────── */
  function initFAQ() {
    $$('.bpo-faq-q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item   = btn.closest('.bpo-faq-item');
        if (!item) return;
        var isOpen = item.classList.contains('open');
        $$('.bpo-faq-item.open').forEach(function (i) {
          i.classList.remove('open');
          var q = i.querySelector('.bpo-faq-q');
          if (q) q.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ── SCROLL REVEAL ──────────────────────────── */
  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      $$('.bpo-reveal').forEach(function (el) { el.classList.add('bpo-vis'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var parent   = entry.target.parentElement;
        var siblings = parent
          ? Array.from(parent.children).filter(function (el) {
              return el.classList.contains('bpo-reveal') && !el.classList.contains('bpo-vis');
            })
          : [];
        var idx = siblings.indexOf(entry.target);
        setTimeout(function () {
          entry.target.classList.add('bpo-vis');
        }, Math.max(0, idx * 80));
        io.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });

    $$('.bpo-reveal').forEach(function (el) { io.observe(el); });
  }

  /* ── ANCHOR SMOOTH SCROLL ───────────────────── */
  function initAnchors() {
    $$('a[href="#bpo-cta"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var el = document.getElementById('bpo-cta');
        if (!el) return;
        e.preventDefault();
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ── INIT ───────────────────────────────────── */
  function init() {
    var qtyEl  = $('bpo-qty');
    var typeEl = $('bpo-type');
    if (qtyEl)  qtyEl.addEventListener('input', calcBPO);
    if (typeEl) typeEl.addEventListener('change', calcBPO);
    calcBPO();
    initFAQ();
    initReveal();
    initAnchors();
  }

  return { init: init };

})();

document.addEventListener('DOMContentLoaded', function () {
  BpoPage.init();
});
